module.exports = __webpack_public_path__ + "img/spinner.d985f74b.svg";